import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { ReactComponent as ArrowLeft } from '../../assets/icons/arrow-left-no-tail.svg'
import { ReactComponent as ArrowRight } from '../../assets/icons/arrow-right-no-tail.svg'
import { getWeekDayNameFull, getWeekDayName } from '../../helpers'
import { DAY_VIEW } from '../../helpers/constants'

import { StyleTimelineHeader, StyleTimelineMiniHeader } from './style'


/**
 * 
 * จำนวนของวันที่จะแสดง ขึ้นอยู่กับการส่ง `startDatetimeHeader` and `endDatetimeHeader` เข้ามา
 * ภายใน Component จะคำนวนให้จาก 2 สิ่งนี้
 */
const TimelineHeader = (props) => {
  const {
    startDatetimeHeader,
    endDatetimeHeader,
    selectedDate,
    language,
    history,
    holidayList,
    headerType,
    headerTextMonth,
  } = props

  const getTimestamp = (date = new Date()) => {
    return new Date(moment(date).format('YYYY-MM-DD')).getTime()
  }

  const changeDate = (date) => {
    history.push(`/calendar/day/${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`)
  }

  const increaseDay = () => {
    const newDate = new Date(moment(selectedDate).add(1, 'd').format())
    changeDate(newDate)
  }

  const decreaseDay = () => {
    const newDate = new Date(moment(selectedDate).subtract(1, 'd').format())
    changeDate(newDate)
  }

  const handleOnClickDateNumber = (day) => {
    if (headerType === 'full') {
      const newDate = new Date(day.currentDatetime)
      changeDate(newDate)
    }
  }

  const renderDayInWeek = () => {
    const timestampOneHour = 1000 * 60 * 60
    const timestampOneDay = timestampOneHour * 24

    const timestampToday = getTimestamp()
    const timestampSelectedDate = getTimestamp(selectedDate)
    const timestampStartDay = getTimestamp(startDatetimeHeader)
    const timestampEndDay = getTimestamp(endDatetimeHeader)

    const days = []
    const totalDay = Math.ceil((timestampEndDay - timestampStartDay) / timestampOneDay)
    for (let i = 0; i <= totalDay; i++) {
      const currentTimestampInLoop = timestampStartDay + (i * timestampOneDay)
      const currentDatetime = new Date(currentTimestampInLoop)
      const name = (headerType === DAY_VIEW.HEADER_TYPE.FULL)
        ? getWeekDayNameFull(currentDatetime, language)
        : getWeekDayName(currentDatetime, language)
      const isPastDay = currentTimestampInLoop < timestampToday
      const isHoliday = holidayList.findIndex(timestampHoliday => getTimestamp(timestampHoliday) === currentTimestampInLoop) !== -1
      const isSelected = (selectedDate && currentTimestampInLoop === timestampSelectedDate)

      days.push({
        name,
        number: currentDatetime.getDate(),
        classToday: currentTimestampInLoop === timestampToday ? ' today' : '',
        classPast: isPastDay ? ' past' : '',
        classHoliday: isHoliday && !isPastDay ? ' holiday' : '',
        classSelected: isSelected || headerType === 'mini' ? ' selected' : '',
        currentDatetime,
      })
    }

    return (
      <div className='day-in-week-container'>
        {days.map((day, index) => {
          return (
            <div key={index} className={`day-in-week${day.classPast}${day.classHoliday}`}>
              <span className={`day-title ${day.name}`}>{day.name.toUpperCase()}</span>
              <span
                className={`day-number${day.classToday}${day.classSelected}`}
                onClick={() => handleOnClickDateNumber(day)}
              >
                {day.number}
              </span>
            </div>
          )
        })}
        {headerType === DAY_VIEW.HEADER_TYPE.MINI && <span>{headerTextMonth}</span>}
      </div>
    )
  }

  return (
    <React.Fragment>
      {headerType === DAY_VIEW.HEADER_TYPE.FULL && (
        <StyleTimelineHeader>

          <div className='previous-day' onClick={decreaseDay}>
            <ArrowLeft />
          </div>

          {renderDayInWeek()}

          <div className='next-day' onClick={increaseDay}>
            <ArrowRight />
          </div>

        </StyleTimelineHeader>
      )}

      {headerType === DAY_VIEW.HEADER_TYPE.MINI && (
        <StyleTimelineMiniHeader>
          {renderDayInWeek()}
        </StyleTimelineMiniHeader>
      )}
    </React.Fragment>
  )
}

TimelineHeader.defaultProps = {
  startDatetimeHeader: new Date(),
  endDatetimeHeader: new Date(),
  selectedDate: new Date(),
  language: 'en',
  history: null,
  holidayList: [],
  headerType: DAY_VIEW.HEADER_TYPE.FULL,
  headerTextMonth: '',
}

TimelineHeader.propTypes = {
  startDatetimeHeader: PropTypes.instanceOf(Date),
  endDatetimeHeader: PropTypes.instanceOf(Date),
  selectedDate: PropTypes.instanceOf(Date),
  language: PropTypes.string,
  history: PropTypes.any,
  holidayList: PropTypes.array,
  headerType: PropTypes.oneOf([DAY_VIEW.HEADER_TYPE.MINI, DAY_VIEW.HEADER_TYPE.FULL]),
  headerTextMonth: PropTypes.string,
}

export default TimelineHeader
